module.exports = __webpack_public_path__ + "static/media/6.e8f15fde.jpg";